/**
 * Correlation-id / idempotency-key generation (§5.1, §5.10-4). Prefers the
 * platform `crypto.randomUUID()` (Node 22 + every evergreen browser); falls
 * back to a manual RFC-4122 v4 generator so the package never hard-crashes
 * in an environment where `crypto` is present but unusually shaped (some
 * older WebView/test runners).
 */
export function generateId() {
    const globalCrypto = globalThis.crypto;
    if (globalCrypto && typeof globalCrypto.randomUUID === 'function') {
        return globalCrypto.randomUUID();
    }
    return fallbackUuidV4();
}
function fallbackUuidV4() {
    const bytes = new Uint8Array(16);
    const globalCrypto = globalThis.crypto;
    if (globalCrypto && typeof globalCrypto.getRandomValues === 'function') {
        globalCrypto.getRandomValues(bytes);
    }
    else {
        for (let i = 0; i < bytes.length; i += 1) {
            bytes[i] = Math.floor(Math.random() * 256);
        }
    }
    const b = bytes;
    b[6] = ((b[6] ?? 0) & 0x0f) | 0x40; // version 4
    b[8] = ((b[8] ?? 0) & 0x3f) | 0x80; // variant 10
    const hex = Array.from(b, (byte) => byte.toString(16).padStart(2, '0'));
    return [
        hex.slice(0, 4).join(''),
        hex.slice(4, 6).join(''),
        hex.slice(6, 8).join(''),
        hex.slice(8, 10).join(''),
        hex.slice(10, 16).join(''),
    ].join('-');
}
